import { toast } from 'sonner'
import { apiError } from '@/lib/api-client'
import { i18n } from '@/lib/i18n'
import { getStages } from '@/lib/lifecycle-stage-cache'
import { useChangeLifecycleStage } from '@/hooks/use-cdp'
import { useStageChangeStore } from '@/stores/stage-change-store'

/**
 * Đổi giai đoạn của MỘT khách do người dùng bấm. Giai đoạn đích có trường bổ sung → mở hộp thoại điền trước
 * (bắt buộc / tuỳ chọn); không có → đổi ngay. Backend vẫn chặn nếu thiếu trường bắt buộc (422).
 */
export function useStageMove() {
  const change = useChangeLifecycleStage()
  const openDialog = useStageChangeStore((s) => s.open)
  return {
    pending: change.isPending,
    move(contactId: string, toStage: string, opts: { name?: string; onDone?: () => void } = {}) {
      const def = getStages().find((s) => s.key === toStage)
      if (def && def.fields.length > 0) {
        openDialog({ contactId, toStage, name: opts.name, onDone: opts.onDone })
        return
      }
      change.mutate(
        { contactId, toStage },
        {
          onSuccess: () => {
            const stage = def?.label ?? toStage
            toast.success(opts.name ? i18n.t('sharedMisc:stageMove.movedNamed', { name: opts.name, stage }) : i18n.t('sharedMisc:stageMove.moved', { stage }))
            opts.onDone?.()
          },
          onError: (e) => toast.error(apiError(e)),
        },
      )
    },
  }
}
